import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionRoot,
  AccordionTrigger,
} from "../../Accordion";
import { orderBy } from "../../../../util/orderBy";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../util/table";
import { ModalProvider } from "../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../Table/TableBasic";
import { useState } from "react";
import useActiveColumns from "../../../../hooks/useActiveColumns";
import { defaultHotellerColumns } from "../../../../config/admin/columnsConfig";
import IngenRegistreringer from "../../../pages/person/id/IngenRegistreringer";
import OpretNyButtonBlock from "../../../pages/person/id/OpretNyButtonBlock";
import { useQuery } from "@tanstack/react-query";
import { get } from "../../../../api/util";
import { SortBy } from "../../../../interfaces/table";
import { adminHotelFormConfig } from "../../../../config/form/admin/adminHotellerFormConfig";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";

const Hoteller = ({ canWrite }: { canWrite: boolean }) => {
  const [sortBy, setSortBy] = useState<SortBy[]>(defaultSortBy);
  const [activeColumns, setActiveColumns] = useActiveColumns(
    `admin-hoteller-active-columns`,
    defaultHotellerColumns,
  );
  const { data, isPending, error, refetch } = useQuery<IHotel[]>({
    queryKey: ["hoteller"],
    queryFn: async function () {
      return get({ query: `hotel` });
    },
  });
  if (error) return <span>Der opstod en fejl</span>;
  if (isPending) return <span>Henter hoteller...</span>;
  if (!data) {
    return (
      <IngenRegistreringer
        invalidateData={refetch}
        editConfig={canWrite ? adminHotelFormConfig(undefined) : undefined}
      />
    );
  }

  return (
    <AccordionRoot>
      <AccordionItem value="Hoteller" className="" isEmpty={false}>
        <AccordionHeader>
          <AccordionTrigger className="ps-3">
            <span>Hoteller</span>
          </AccordionTrigger>
        </AccordionHeader>
        <AccordionContent className="c-card c-card--accordion mb-4">
          <ModalProvider>
            <TableRoot>
              <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
                <>
                  {getHeaderActiveColumns(activeColumns, {
                    defaultSortBy,
                    setSortBy,
                    sortBy,
                  })}
                </>
              </TableHead>
              <TableBody>
                {orderBy(
                  data,
                  sortBy.map((s) => s.field),
                  sortBy.map((s) => s.direction),
                ).map((rowData, i) => {
                  return (
                    <TableRow
                      key={i}
                      editConfig={
                        canWrite ? adminHotelFormConfig(rowData.id) : undefined
                      }
                      invalidateData={refetch}
                    >
                      <>
                        {activeColumns.map((col) => {
                          return (
                            <TD key={col.field} col={col} rowData={rowData} />
                          );
                        })}
                      </>
                    </TableRow>
                  );
                })}
              </TableBody>
            </TableRoot>
            <ColumnEditorModal
              defaultColumns={defaultHotellerColumns}
              columns={activeColumns}
              setActiveColumns={setActiveColumns}
            />
            <OpretNyButtonBlock
              editConfig={
                canWrite ? adminHotelFormConfig(undefined) : undefined
              }
              invalidateData={refetch}
            />
          </ModalProvider>
        </AccordionContent>
      </AccordionItem>
    </AccordionRoot>
  );
};

const defaultSortBy: SortBy<HotellerFields>[] = [
  {
    direction: "asc",
    field: "navn1",
  },
];

export default Hoteller;
